function sanitizeFilename(filename, fallbackFilename) {
  const value = String(filename || fallbackFilename || '资产评估报告')
    .replace(/[\\/:*?"<>|]/g, '_')
    .trim();

  return value || '资产评估报告';
}

function getFilenameFromDisposition(disposition) {
  if (!disposition) {
    return '';
  }

  const utf8Match = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch (error) {
      return utf8Match[1];
    }
  }

  const filenameMatch = disposition.match(/filename\s*=\s*(?:"([^"]+)"|([^;\s]+))/i);
  return filenameMatch ? (filenameMatch[1] || filenameMatch[2]) : '';
}

function getFilenameFromUrl(url) {
  const pathname = new URL(url, window.location.href).pathname;
  const filename = pathname.split('/').pop();
  return filename ? decodeURIComponent(filename) : '';
}

function isErrorResponse(contentType) {
  return /(?:application|text)\/(?:json|xml|html)|\+xml/i.test(contentType || '');
}

export async function downloadFile(url, fallbackFilename) {
  if (!url || typeof url !== 'string') {
    throw new Error('下载地址无效');
  }

  let response;
  try {
    new URL(url, window.location.href);
    response = await fetch(url, { credentials: 'omit' });
  } catch (error) {
    throw new Error('报告文件无法访问，请检查对象存储的跨域来源配置');
  }

  const contentType = response.headers.get('content-type') || '';
  if (!response.ok || isErrorResponse(contentType)) {
    throw new Error('报告文件暂时无法下载，请稍后重试');
  }

  const blob = await response.blob();
  if (!blob.size) {
    throw new Error('报告文件为空，请稍后重试');
  }

  const filename = sanitizeFilename(
    getFilenameFromDisposition(response.headers.get('content-disposition')) || getFilenameFromUrl(url),
    fallbackFilename
  );
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000);
}
